// SCR-017's route (NAV-011 audit log), composed into the route table by TASK-140. NAV-011 is open
// to "super-admin; billing and installer principals" (user-flows NAV-011) — the API expresses that
// with `x-nexus-permission-any-of: [billing:read, installer:run]` (API-037); the router's
// `Requirement` now has the matching any-of form (session/session.ts's `anyOf`), so the route
// gates and the nav entry only appear together, exactly for principals who can see some event.
import { defineRoute, type ScreenRoute } from "../../router/route";
import { anyOf } from "../../session/session";
import { AUDIT_PATH } from "./model";
import { Audit } from "./audit";

export const routes: ScreenRoute[] = [
  defineRoute({
    nav: "NAV-011",
    path: AUDIT_PATH,
    title: "Audit log",
    permission: anyOf("billing:read", "installer:run"),
    component: Audit,
  }),
];
